module.exports = __webpack_public_path__ + "static/media/img_20.e43d250b.JPG";